export const detectAssetRequestIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete asset request" || cleaned === "remove asset request") {
        return { intent: "delete_asset_request" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) asset request/);
    if (deleteMatch) {
        return { intent: "delete_asset_request", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create asset request") || cleaned.includes("add asset request")) {
        return { intent: "create_asset_request" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create asset request named (.+)/);
    if (createMatch) {
        return { intent: "create_asset_request", name: createMatch[1].trim() };
    }

    return null;
};
